import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=0233ccb4&scoped=true&"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts&"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=0233ccb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233ccb4",
  null
  
)

export default component.exports